import SideBarTool from "@/commons/components/side-bar-tool";
import { Select } from "antd";
import { useState } from "react";
import { HavcDeviceExhaustOpeningRectanglePanel, HavcDeviceExhaustOpeningRoundPanel } from "./exhaust-opening"
import HavcDeviceVortexFanPanel from "./vortex-fan"
import HavcDeviceSuppressorPanel from "./suppressor"

const enum HavcDeviceType {
    EXHAUST_OPENING_RECTANGLE, // 排风口-矩形
    EXHAUST_OPENING_ROUND,     // 排风口-圆形
    VORTEX_FAN,                // 漩涡风机
    SUPPRESSOR,                // 消音器
}

/**
 * 暖通设备
 */
export default function HavcDeviceBlockPanel() {
    // const { projectId } = useParams();
    const [selDeviceType, setSelDeviceType] = useState<HavcDeviceType>(HavcDeviceType.EXHAUST_OPENING_RECTANGLE);
    const onDeviceTypeChange = (deviceType: HavcDeviceType) => {
        setSelDeviceType(deviceType);
    }

    return (
        <div className="side-bar-main">
            <SideBarTool
                activeBtnList={[]}
            />
            <div className="body">
                <div className="title">
                    设备
                </div>
                <div className="detail structure-beam-panel">
                    <div className="row compact">
                        <div className="label">类型</div>
                        <Select
                            size='small'
                            className="select-box"
                            value={selDeviceType}
                            onChange={onDeviceTypeChange}
                            dropdownStyle={{ maxHeight: '183px', overflow: 'auto' }}
                        >
                            <Select.Option value={HavcDeviceType.EXHAUST_OPENING_RECTANGLE}>排风口-矩形</Select.Option>
                            <Select.Option value={HavcDeviceType.EXHAUST_OPENING_ROUND}>排风口-圆形</Select.Option>
                            <Select.Option value={HavcDeviceType.VORTEX_FAN}>漩涡风机</Select.Option>
                            <Select.Option value={HavcDeviceType.SUPPRESSOR}>消音器</Select.Option>
                        </Select>
                    </div>
                    {
                        selDeviceType === HavcDeviceType.EXHAUST_OPENING_RECTANGLE &&
                        <HavcDeviceExhaustOpeningRectanglePanel />
                    }
                    {
                        selDeviceType === HavcDeviceType.EXHAUST_OPENING_ROUND &&
                        <HavcDeviceExhaustOpeningRoundPanel />
                    }
                    {
                        selDeviceType === HavcDeviceType.VORTEX_FAN &&
                        <HavcDeviceVortexFanPanel />
                    }

                    {
                        selDeviceType === HavcDeviceType.SUPPRESSOR &&
                        <HavcDeviceSuppressorPanel />
                    }
                </div>
            </div>
        </div>
    )
}